export default "__VITE_ASSET__fb36c59e__"